import * as yup from 'yup';

const SchemaBusinessClientes = yup.object().shape({
  clientes: yup.array()
});

export { SchemaBusinessClientes };
